import SvgIcon from '@/pages/home/components/SvgIcon';
import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { Bubble } from 'tea-component';

const IconDom = (porps: any) => {
  const { data = {} } = porps;
  const { text, svg, img, disabled, className, imgClassName, hideText, tooltip } = data;

  const containerClassName = classNames('dbi-select-icon-show', className, {
    'is-disabled': disabled,
  });
  const bubbleContent = tooltip ?? text;

  return (
    <div className={containerClassName}>
      <Bubble placement="top" dark content={bubbleContent}>
        <>
          {svg ? <img src={svg} className={classNames('dbi-select-icon', imgClassName)} alt="" /> : null}
          {img ? <img src={img} className={classNames('dbi-select-img', imgClassName)} alt="" /> : null}
          {!hideText && text ? <span>{text}</span> : null}
        </>
      </Bubble>
    </div>
  );
};

export default IconDom;
